module.exports = __webpack_public_path__ + "img/LUNAS_WATERMARK.dc33cb43.svg";